export default {
  download: 'Download',
  sendUnlockDoenload: 'Abilita download',
  cancelUnlockDownload: 'Annulla',
  requestPhysicalAppointment: 'Richiedi appuntamento in showroom',
  requestDigitalAppointment: 'Prenota un appuntamento virtuale',
  sendRequest: 'Invia la richiesta',
  login: 'Login',
}
